import { ExternalLink } from 'lucide-react'

const LINKEDIN = 'https://www.linkedin.com/in/mindful-abhay/'
const BUYMECOFFEE = 'https://buymeacoffee.com/abhaypratapsingh'

export function CreatorLinks({ variant = 'compact' }: { variant?: 'compact' | 'hero' | 'footer' }) {
  if (variant === 'hero') {
    return (
      <div className="flex items-center justify-center gap-4 text-sm">
        <a href={LINKEDIN} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full border border-[var(--border)] hover:bg-[var(--bg-panel)]">
          <ExternalLink size={14} /> LinkedIn
        </a>
        <a href={BUYMECOFFEE} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full border border-[var(--border)] hover:bg-[var(--bg-panel)]">
          <ExternalLink size={14} /> Buy me a coffee
        </a>
      </div>
    )
  }
  if (variant === 'footer') {
    return (
      <div className="flex items-center gap-4 text-xs">
        <a href={LINKEDIN} target="_blank" rel="noreferrer" className="hover:text-[var(--text)] flex items-center gap-1">
          <span>LinkedIn</span> <ExternalLink size={11} />
        </a>
        <a href={BUYMECOFFEE} target="_blank" rel="noreferrer" className="hover:text-[var(--text)] flex items-center gap-1">
          <span>Buy me a coffee</span> <ExternalLink size={11} />
        </a>
        <span className="text-[var(--text-subtle)]/60">Abhay Pratap Singh</span>
      </div>
    )
  }
  return (
    <div className="flex items-center gap-2 text-xs text-[var(--text-subtle)]">
      <a href={LINKEDIN} target="_blank" rel="noreferrer" className="hover:text-[var(--text)]">LinkedIn</a>
      <span className="opacity-40">·</span>
      <a href={BUYMECOFFEE} target="_blank" rel="noreferrer" className="hover:text-[var(--text)]">Buy me a coffee</a>
    </div>
  )
}
